import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './ChatComponent.css';
import {sendAllowAllPostRequest, getRequestAllowAll} from "../Services/ContrectBackendAPI";
import UserProfile from "../Context/UserProfile";
import OtherData from '../Context/OtherData';

const ChatComponent = () => {
  const navigate = useNavigate();
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const modelName="gpt-4.1-mini";
  const [chatState, setChatState] = useState({
    messages: [],
    currentQuestion: null,
    userInput: '',
    selectedOption: '',
    oldAnswers: [],
    isLoading: false,
    isComplete: false
  });
  const [aIInputContractName,setAIInputContractName]=useState("");
  const [aIInputRole,setAIInputRole]=useState("");
  const [aIOtherPartyDetail,setAIOtherPartyDetail]=useState("");
  const [aIGenItems,setAiGenItems]=useState("");
  const [aIOtherNote,setAIOtherNote]=useState("");
  const [questionCompleted,setQuestionCompleted]=useState(false);
  // First fixed question
  const firstQuestion = {
    id: 'initial',
    question: 'What type of contract you want to make?',
    options: ['Service Agreement', 'Employment Contract', 'NDA', 'Lease Agreement', 'Partnership Agreement', 'Sales Contract']
  };

  // Initialize with first question
  useEffect(() => {
    setChatState(prev => ({
      ...prev,
      currentQuestion: firstQuestion,
      messages: [{
        id: 'initial-question',
        type: 'bot',
        content: firstQuestion.question,
        options: firstQuestion.options
      }]
    }));
    setAIInputContractName('');

    setQuestionCompleted(false);
  }, []);

  // Scroll to bottom when messages change
  useEffect(() => {
    scrollToBottom();
  }, [chatState.messages]);

  const scrollToBottom = () => {
    // messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    if (chatContainerRef.current && messagesEndRef.current) {
    const container = chatContainerRef.current;
    const target = messagesEndRef.current;
    
    // Scroll to the bottom of the container
    container.scrollTop = container.scrollHeight;
    
    // Or if you want smooth scrolling:
    container.scrollTo({
      top: container.scrollHeight,
      behavior: 'smooth'
    });
  }
  };

  const handleOptionSelect = (option) => {
    setChatState(prev => ({
      ...prev,
      selectedOption: option
    }));
  };

  const handleInputChange = (e) => {
    setChatState(prev => ({
      ...prev,
      userInput: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const { selectedOption, userInput, oldAnswers, currentQuestion } = chatState;
    
    if (!selectedOption && !userInput.trim()) {
      alert('Please select an option or provide input');
      return;
    }

    // Add user's response to messages
    const userResponse = selectedOption + (userInput.trim() ? ` (Additional: ${userInput})` : '');
    
    setChatState(prev => ({
      ...prev,
      messages: [
        ...prev.messages,
        {
          id: `user-${Date.now()}`,
          type: 'user',
          content: userResponse
        }
      ],
      isLoading: true,
      userInput: '',
      selectedOption: ''
    }));

    // Update oldAnswers
    const newAnswer = {
      questionId: currentQuestion.id,
      question: currentQuestion.question,
      selectedOption: selectedOption,
      additionalInput: userInput.trim()
    };

    const updatedOldAnswers = [...oldAnswers, newAnswer];

    try {
      if (currentQuestion.id === 'initial') {
        setAIInputContractName(selectedOption||userInput.trim());
        await getPartyInvolved(selectedOption||userInput.trim());
      } else {
        if(!aIInputRole.trim()){
          setAIInputRole(selectedOption||userInput.trim())
          let allAns="";
            for(let i=0;i<updatedOldAnswers.length;i++){
                allAns+=`Q: ${updatedOldAnswers[i].question} A: ${updatedOldAnswers[i].selectedOption} ${updatedOldAnswers[i].additionalInput}`;
            }
            const result = await sendAllowAllPostRequest("api/Assistant/getQuestionsWithoutToken", {
            OutputCount: 1,
            Statement: aIInputContractName,
            ModelName: modelName, // Replace with actual model name
            OldAnswers: allAns
            });
            console.log(allAns);
            const response = await result.json();
            console.log(response);
            if (response && response.status===1) {
                
                let allQOptions=[];
                  for(let i=0;i<response.data[0].options.length;i++){
                      allQOptions.push(response.data[0].options[i].valueToDisplay);
                  }
                  const nextQuestion = {
                  id: "Question-"+ Date.now().toString(),
                  question: response.data[0].question,
                  options: allQOptions || []
                  };

                  setChatState(prev => ({
                  ...prev,
                  currentQuestion: nextQuestion,
                  messages: [
                      ...prev.messages,
                      {
                      id: `bot-${Date.now()}`,
                      type: 'bot',
                      content: nextQuestion.question,
                      options: nextQuestion.options
                      }
                  ],
                  oldAnswers: updatedOldAnswers,
                  isLoading: false
                  }));
            }else{
                alert("Error fetching next question. Please try again.");
            }
        }
        else if(questionCompleted!==true){
          console.log("Inside askQuestion state value",questionCompleted);
            let allAns="";
            for(let i=0;i<updatedOldAnswers.length;i++){
                allAns+=`Q: ${updatedOldAnswers[i].question} A: ${updatedOldAnswers[i].selectedOption} ${updatedOldAnswers[i].additionalInput}`;
            }
            const result = await sendAllowAllPostRequest("api/Assistant/getQuestionsWithoutToken", {
            OutputCount: 1,
            Statement: aIInputContractName,
            ModelName: modelName, // Replace with actual model name
            OldAnswers: allAns
            });
            console.log(allAns);
            const response = await result.json();
            console.log(response);
            if (response && response.status===1) {
                
                if (response.data[0].action==="generate_contract") {
                    // More questions available
                    setQuestionCompleted(true);
                    const nextQuestion = {
                      id: "Question-"+ Date.now().toString(),
                      question: "Do you want AI to generate Items in contract?",
                      options: ["Yes","No"]
                      };

                      setChatState(prev => ({
                      ...prev,
                      currentQuestion: nextQuestion,
                      messages: [
                          ...prev.messages,
                          {
                          id: `bot-${Date.now()}`,
                          type: 'bot',
                          content: nextQuestion.question,
                          options: nextQuestion.options
                          }
                      ],
                      oldAnswers: updatedOldAnswers,
                      isLoading: false
                      }));
                      return;
                }else{
                  let allQOptions=[];
                  for(let i=0;i<response.data[0].options.length;i++){
                      allQOptions.push(response.data[0].options[i].valueToDisplay);
                  }
                  const nextQuestion = {
                  id: "Question-"+ Date.now().toString(),
                  question: response.data[0].question,
                  options: allQOptions || []
                  };

                  setChatState(prev => ({
                  ...prev,
                  currentQuestion: nextQuestion,
                  messages: [
                      ...prev.messages,
                      {
                      id: `bot-${Date.now()}`,
                      type: 'bot',
                      content: nextQuestion.question,
                      options: nextQuestion.options
                      }
                  ],
                  oldAnswers: updatedOldAnswers,
                  isLoading: false
                  }));
                }
            }else{
                alert("Error fetching next question. Please try again.");
            }
        }else if(!aIGenItems.trim()){
            setAiGenItems(selectedOption||userInput.trim());
            const nextQuestion = {
              id: "Question-"+ Date.now().toString(),
              question: "Any other especific notes for the contract?",
              options: ["No"]
              };

              setChatState(prev => ({
              ...prev,
              currentQuestion: nextQuestion,
              messages: [
                  ...prev.messages,
                  {
                  id: `bot-${Date.now()}`,
                  type: 'bot',
                  content: nextQuestion.question,
                  options: nextQuestion.options
                  }
              ],
              oldAnswers: updatedOldAnswers,
              isLoading: false
              }));
        }else if(!aIOtherNote.trim()){
          setAIOtherNote(selectedOption||userInput.trim());
            const nextQuestion = {
              id: "Question-"+ Date.now().toString(),
              question: "Please let us know the contact number of other party?",
              options: []
              };

              setChatState(prev => ({
              ...prev,
              currentQuestion: nextQuestion,
              messages: [
                  ...prev.messages,
                  {
                  id: `bot-${Date.now()}`,
                  type: 'bot',
                  content: nextQuestion.question,
                  options: nextQuestion.options
                  }
              ],
              oldAnswers: updatedOldAnswers,
              isLoading: false,
              userInput:"+91"
              }));
        }else if(!aIOtherPartyDetail.trim()){
          if( /^\+91[6-9]\d{9}$/.test(userInput.trim())===false){
              alert("Error","Please enter valid contact number with country code.");
              return;
          }
          setAIOtherPartyDetail(selectedOption||userInput.trim());
          setChatState(prev => ({
          ...prev,
          oldAnswers: updatedOldAnswers,
          isLoading: false
          }));
          await generateContract(userInput);
        }
        
      }
    } catch (error) {
      console.error('Error fetching next question:', error);
      setChatState(prev => ({
        ...prev,
        isLoading: false,
        messages: [
          ...prev.messages,
          {
            id: `error-${Date.now()}`,
            type: 'bot',
            content: 'Sorry, there was an error. Please try again.'
          }
        ]
      }));
    }
  };
  const generateContract = async (lastAnswer) => {
    //setAILoading(true);
    
    try {
        //const token = await AsyncStorage.getItem('token');
        // if (!token) {
        //     Alert.alert('Error', 'Please login again');
        //     return;
        // }
        let initialAgreementData = {
          id: 0,
          contractUid: "",
          contractName: "",
          contractDescription: "",
          createdById: UserProfile.getUserId(),
          sellerId: 0,
          sellerName: "",
          sellerPhoneNumber: "+910000000000",
          buyerId: 0,
          buyerName:  "",
          buyerPhoneNumber: "+910000000000",
          ldInfo:  "",
          status:  "",
          agreementAdvancePercent: 0,
          agreementSecurityAmount:  0,
          currency:  "INR",
          agreementStartDate: new Date(),
          agreementEndDate: new Date(),
          createdOn: new Date(),
          autoGenInvoice: false,
          agreementLdPercent:  0,
          agreementLdAppliedAfterDays:  0,
          agreementCompletionInDays:  0,
          agreementStatusId:  0,
          agreementSecurityReceived:false,
          agreementSecurityReturned: false,
          currencyId:  2,
          items: [],
          terms: [],
          generatedByAI:true
          };
        let otherInformation="";
        let involvedParty="";
        const roleCategory= await getRequestAllowAll("api/Assistant/getPartyCategoryWithoutToken?contract="+aIInputRole+"&modelName="+modelName);
          const roleCategoryJson=await roleCategory.json();
          //setAIGeneratedAgreement(true);
          let phone=UserProfile.getPhoneNumber();
          let email=UserProfile.getEmail();
          // console.log("Issue Role-", roleCategoryJson);
          if(roleCategoryJson && roleCategoryJson.status===1 
            && roleCategoryJson.data 
            && (roleCategoryJson.data.toLowerCase().includes("buyer")||roleCategoryJson.data.toLowerCase().includes("1")))
          {
            involvedParty+="Buyer- "+phone+" , "+email+" Seller- "+lastAnswer;
            //setSelected("Buyer");
          }else if(roleCategoryJson && roleCategoryJson.status===1 
            && roleCategoryJson.data 
            &&( roleCategoryJson.data.toLowerCase().includes("seller")||roleCategoryJson.data.toLowerCase().includes("2")))
          {
            //setSelected("Seller");
            involvedParty+="Seller- "+phone+" , "+email+" Buyer- "+lastAnswer;
          }else{
            //setSelected("Buyer");
            involvedParty+="Buyer- "+phone+" , "+email+" Seller- "+lastAnswer;
          }
        for(let o=0;o<chatState.oldAnswers.length;o++){
          otherInformation+=" Question-"+chatState.oldAnswers[o].question+" Answer-"+chatState.oldAnswers[o].selectedOption
          +" "+chatState.oldAnswers[o].additionalInput;
          
        }
        setChatState(prev => ({
        ...prev,
        userInput:''
      }));
        // var currency=itemCurrencyOptions.find(x=>x.typeValue==="INR"); 
        // setDefaultCurrency(currency ? currency.id:2);
        const response = await sendAllowAllPostRequest('api/Assistant/genAIContractWithoutLogin', {
          ContractName:aIInputContractName,
          InvolvedParties:involvedParty,
          OtherInformation:otherInformation,
          ModelName:modelName,
          GenerateItems:aIGenItems!=="No",
        });
        const result = await response.json();
        // console.log(result.data.items[0]);
        if (result.status === 1 && result.data) {
            const generatedContract = result.data;
            console.log("GeneratedData:",JSON.stringify(generatedContract));
            if(generatedContract.firstPartyOrBuyer.phoneNumber===phone)
            {
              initialAgreementData.sellerId=0;
              initialAgreementData.buyerId=UserProfile.getUserId();
              initialAgreementData.buyerPhoneNumber=generatedContract.firstPartyOrBuyer.phoneNumber;
              initialAgreementData.sellerPhoneNumber=generatedContract.secondPartyOrSeller.phoneNumber;
            }else{
              initialAgreementData.sellerId=UserProfile.getUserId();
              initialAgreementData.buyerId=0;
              initialAgreementData.buyerPhoneNumber=generatedContract.firstPartyOrBuyer.phoneNumber;
              initialAgreementData.sellerPhoneNumber=generatedContract.secondPartyOrSeller.phoneNumber;
            }
            // Populate the agreement form with generated data
            let aiItems=[];
            let aiTerms=[];
            if(generatedContract.terms.length>0)
            {
              for(let t=0;t<generatedContract.terms.length;t++)
              {
                aiTerms.push({
                    id: 0,
                    termTitle: generatedContract.terms[t].termTitle,
                    termTxt: generatedContract.terms[t].termTxt,
                    termAttachments: [],
                    agreementId: 0,
                    isDeleted: false,
                });
              }
            }
            
            if(generatedContract.items.length>0)
            {
              for(let i=0;i<generatedContract.items.length;i++)
              {
                aiItems.push({
                  id: 0,
                  itemHsnSac: generatedContract.items[i].itemHsnCsnUin?generatedContract.items[i].itemHsnCsnUin:"",
                  itemTitle: generatedContract.items[i].itemTitle,
                  itemDescription: generatedContract.items[i].itemDescription,
                  itemQuantity: generatedContract.items[i].itemQuantity,
                  itemRate: generatedContract.items[i].itemRate,
                  itemTax: 0,
                  itemDeliveredInDays: 1,
                  itemUnitId: 1,
                  agreementId:0,
                  itemAttachments: [],
                  createdOn: new Date(),
                  unitName:"CNT"
                });
              }
            }
            initialAgreementData.contractName= generatedContract.contractTitle || `AI Generated ${aIInputContractName}`;
            initialAgreementData.agreementCompletionInDays= generatedContract.contractCompletionInDays || 30;
            initialAgreementData.agreementAdvancePercent= generatedContract.contractAdvanceAmount || 0;
            initialAgreementData.agreementLdAppliedAfterDays= generatedContract.contractLdAppliedAfterDays || 0;
            initialAgreementData.agreementLdPercent= generatedContract.contractLdPercent || 0;
            initialAgreementData.agreementSecurityAmount= generatedContract.contractDepositAmount || 0;
            initialAgreementData.contractDescription=generatedContract.contractDesccription || "";
            initialAgreementData.items= aiItems;
            initialAgreementData.terms= aiTerms;

            // Add success message
            const successMessage = {
              id: `Success-${Date.now()}`,
                type: 'bot',
                content: "Draft ready! Review and edit the structured contract before sending.",
                options: []
            };
            setChatState(prev => ({
            ...prev,
            currentQuestion: "",
            messages: [
              ...prev.messages,
              successMessage
            ],
            oldAnswers: chatState.oldAnswers,
            isLoading: false
          }));

            // Close modal after 2 seconds
            setTimeout(() => {
              console.log(JSON.stringify(initialAgreementData));
                OtherData.setData(JSON.stringify(initialAgreementData));
                navigate("/DraftContract");
            }, 5000);
        } else {
            // Mock success for demo
            alert("Error","Not able to get AI generate data");
            navigate("/");
            
        }
    } catch (error) {
        console.error('Contract generation error:', error);
        alert('Error', 'Failed to generate contract');
    } finally {
        //setAILoading(false);
    }
};
  const getPartyInvolved=async (contractName)=>{

      const res=await getRequestAllowAll("api/Assistant/getInvolvedPartiesWithoutToken?contract="+contractName+"&modelName="+modelName);
        const resJson= await res.json();

        if (resJson.status === 1 && resJson.data ) {
            
            let options=[];
            for(let y=0;y<resJson.data.options.length;y++)
            {
              options.push(resJson.data.options[y].valueToDisplay);
            }
            
            const nextQuestion = {
            id: "Question-"+ Date.now().toString(),
            question: resJson.data.question,
            options: options || []
            };  
            setChatState(prev => ({
            ...prev,
            currentQuestion: nextQuestion,
            messages: [
              ...prev.messages,
              {
                id: `bot-${Date.now()}`,
                type: 'bot',
                content: nextQuestion.question,
                options: nextQuestion.options
              }
            ],
            oldAnswers: [],
            isLoading: false
          }));
        } else {
            // Mock data for demo
            const mockQuestions = [
                {
                    id: "Question-"+ Date.now().toString(),
                    question: 'What is your role in this contract?',
                    options: ['Buyer or First Party', 'Seller or 2nd Party'],
                    
                }
            ];
            setChatState(prev => ({
            ...prev,
            currentQuestion: mockQuestions,
            messages: [
              ...prev.messages,
              {
                id: `bot-${Date.now()}`,
                type: 'bot',
                content: mockQuestions.question,
                options: mockQuestions.options
              }
            ],
            oldAnswers: [],
            isLoading: false
          }));

        }
};
  const renderMessage = (message) => {
    if (message.type === 'bot') {
      return (
        <div className="message bot-message" key={message.id}>
          <div className="message-content">
            <div className="message-text">{message.content}</div>
            {message.options && message.options.length > 0 && (
              <div className="options-container">
                {message.options.map((option, index) => (
                  <button
                    key={index}
                    className={`option-button ${chatState.selectedOption === option ? 'selected' : ''}`}
                    onClick={() => handleOptionSelect(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className="message user-message" key={message.id}>
        <div className="message-content">
          <div className="message-text">{message.content}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="chat-container">
      <div className="chat-header">
        <h2>Contract Assistant</h2>
      </div>
      
      <div className="chat-messages" ref={chatContainerRef}>
        
        {chatState.messages.map(renderMessage)}
        
        {chatState.isLoading && (
          <div className="message bot-message">
            <div className="message-content">
              <div className="loading-dots">
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </div>
            </div>
          </div>
        )}
        
        {chatState.isComplete && (
          <div className="message bot-message">
            <div className="message-content">
              <div className="message-text">Thank you! Redirecting to next page...</div>
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />

        
      </div>

      {!chatState.isLoading && !chatState.isComplete && (
        <form className="chat-input-form" onSubmit={handleSubmit}>
          <div className="input-container">
            <input
              type="text"
              value={chatState.userInput}
              onChange={handleInputChange}
              placeholder="Add additional information (optional)"
              className="text-input"
            />
            <button 
              type="submit" 
              className="submit-button"
              disabled={!chatState.selectedOption && !chatState.userInput.trim()}
            >
              Send
            </button>
          </div>
          <div className="hint-text">
            {chatState.selectedOption ? 
              `Selected: ${chatState.selectedOption}` : 
              'Please select an option above or type additional information'}
          </div>
        </form>
      )}
    </div>
  );
};

export default ChatComponent;